import { motion, useInView } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';
import FacebookIcon from '../../../components/icon/facebook-icon';
import InstagramIcon from '../../../components/icon/instagram-icon';
import TikTokIcon from '../../../components/icon/tiktok-icon';
import TwitterIcon from '../../../components/icon/twitter-icon';
import YoutubeIcon from '../../../components/icon/youtube-icon';
import "./social-media-calendar-landing-card.scss"


const SocialMediaCalendarLandingCard = () => {
    const BASE_DELAY_S = 0.1;
    const [visible, isVisible] = useState(false);

    const calendarWrapperRef = useRef<HTMLDivElement>(null)
    const inView = useInView(calendarWrapperRef, { amount: "all", once: true });

    useEffect(() => {
        isVisible(inView)
    }, [inView])

    const eventPillVariants = {
        hidden: {
            opacity: 0,
            boxShadow: "0px 0px 0px 0px rgba(59, 134, 247, 0.2)",
            transition: { duration: 0.4 }
        },
        visible: {
            opacity: 1,
            boxShadow: "0px 8px 42px 10px rgba(59, 134, 247, 0.2)",
        }
    }


    return (

        <div ref={calendarWrapperRef} className='emrg-demo-cards schedule-card'>
            <div className='card-header'>
                <h3>Schedule</h3>
                <p className='color-gray-300'>Effortlessly schedule and track your social media blasts with our platform</p>
            </div>
            <div className='calendar-wrapper'>
                <div className='emp-calendar'>
                    <div className='calendar-row'>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>1</span>
                                <span className='day'>Mon</span>
                            </div>
                            <div className='events'>
                                <motion.div className='item'
                                    variants={eventPillVariants}
                                    initial="hidden"
                                    animate={visible ? "visible" : "hidden"}
                                    transition={{ delay: BASE_DELAY_S * 0 }}>
                                    <TwitterIcon
                                        backgroundColor={"rgba(255, 255, 255, 0.6)"}
                                        size={12}
                                    />
                                    <span>Post</span>
                                </motion.div>
                                <motion.div className='item'
                                    variants={eventPillVariants}
                                    initial="hidden"
                                    animate={visible ? "visible" : "hidden"}
                                    transition={{ delay: BASE_DELAY_S * 5 }}>
                                    <TikTokIcon
                                        backgroundColor={"rgba(255, 255, 255, 0.6)"}
                                        size={12}
                                    />
                                    <span>Video</span>
                                </motion.div>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>2</span>
                                <span className='day'>Tue</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>3</span>
                                <span className='day'>Wed</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>4</span>
                                <span className='day'>Thu</span>
                            </div>
                            <div className='events'>
                                <motion.div className='item'
                                    variants={eventPillVariants}
                                    initial="hidden"
                                    animate={visible ? "visible" : "hidden"}
                                    transition={{ delay: BASE_DELAY_S * 3 }}>

                                    <YoutubeIcon
                                        backgroundColor={"rgba(255, 255, 255, 0.6)"}
                                        size={14}
                                    />
                                    <span>Video</span>
                                </motion.div>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>5</span>
                                <span className='day'>Fri</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>6</span>
                                <span className='day'>Sat</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>7</span>
                                <span className='day'>Sun</span>
                            </div>
                        </div>
                    </div>
                    <div className='calendar-row'>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>8</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>9</span>
                            </div>
                            <div className='events'>
                                <motion.div className='item'
                                    variants={eventPillVariants}
                                    initial="hidden"
                                    animate={visible ? "visible" : "hidden"}
                                    transition={{ delay: BASE_DELAY_S * 1 }}>

                                    <TikTokIcon
                                        backgroundColor={"rgba(255, 255, 255, 0.6)"}
                                        size={12}
                                    />
                                    <span>Video</span>
                                </motion.div>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>10</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>11</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>12</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>13</span>
                            </div>
                            <div className='events'>
                                <motion.div className='item'
                                    variants={eventPillVariants}
                                    initial="hidden"
                                    animate={visible ? "visible" : "hidden"}
                                    transition={{ delay: BASE_DELAY_S * 8 }}
                                >
                                    <FacebookIcon
                                        backgroundColor={"rgba(255, 255, 255, 0.6)"}
                                        size={12}
                                    />
                                    <span>Post</span>
                                </motion.div>
                                <motion.div className='item'
                                    variants={eventPillVariants}
                                    initial="hidden"
                                    animate={visible ? "visible" : "hidden"}
                                    transition={{ delay: BASE_DELAY_S * 9 }}>
                                    <TwitterIcon
                                        backgroundColor={"rgba(255, 255, 255, 0.6)"}
                                        size={12}
                                    />
                                    <span>Post</span>
                                </motion.div>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>14</span>
                            </div>
                        </div>
                    </div>
                    <div className='calendar-row'>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>15</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>16</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>17</span>
                            </div>
                            <div className='events'>
                                <motion.div className='item'
                                    variants={eventPillVariants}
                                    initial="hidden"
                                    animate={visible ? "visible" : "hidden"}
                                    transition={{ delay: BASE_DELAY_S * 2 }}>
                                    <InstagramIcon
                                        backgroundColor={"rgba(255, 255, 255, 0.6)"}
                                        size={12}
                                    />
                                    <span>Reel</span>
                                </motion.div>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>18</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>19</span>
                            </div>
                            <div className='events'>
                                <motion.div className='item'
                                    variants={eventPillVariants}
                                    initial="hidden"
                                    animate={visible ? "visible" : "hidden"}
                                    transition={{ delay: BASE_DELAY_S * 4 }}>
                                    <FacebookIcon
                                        backgroundColor={"rgba(255, 255, 255, 0.6)"}
                                        size={12}
                                    />
                                    <span>Post</span>
                                </motion.div>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>20</span>
                            </div>
                        </div>
                        <div className="calendar-cell">
                            <div className='details'>
                                <span className='date'>21</span>
                            </div>
                            <div className='events'>
                                <motion.div className='item'
                                    variants={eventPillVariants}
                                    initial="hidden"
                                    animate={visible ? "visible" : "hidden"}
                                    transition={{ delay: BASE_DELAY_S * 6 }}>
                                    <TwitterIcon
                                        backgroundColor={"rgba(255, 255, 255, 0.6)"}
                                        size={12}
                                    />
                                    <span>Post</span>
                                </motion.div>
                                <motion.div className='item'
                                    variants={eventPillVariants}
                                    initial="hidden"
                                    animate={visible ? "visible" : "hidden"}
                                    transition={{ delay: BASE_DELAY_S * 7 }}>

                                    <TikTokIcon
                                        backgroundColor={"rgba(255, 255, 255, 0.6)"}
                                        size={12}
                                    />
                                    <span>Video</span>
                                </motion.div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>


    )
}
export default SocialMediaCalendarLandingCard